<!-- Modal Overlay - ISSUE 4 FIX: Removed (click)="onClose()" to prevent backdrop close -->
<div *ngIf="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

  <!-- Modal Content -->
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <h3 class="text-xl font-bold">🚀 Configuración por Lotes</h3>
          <div class="flex items-center space-x-2">
            <span class="text-sm opacity-90">{{ totalSelectedReceipts }} comprobantes seleccionados</span>
          </div>
        </div>

        <!-- Close Button -->
        <button type="button" (click)="onClose()"
          class="p-2 rounded-lg bg-white bg-opacity-20 hover:bg-opacity-30 transition-all">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Tabs -->
      <div class="flex space-x-1 mt-4">
        <button type="button" (click)="setActiveTab('amounts')"
          [class]="activeTab === 'amounts' ? 'bg-white bg-opacity-20 text-white' : 'text-purple-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          💵 Montos
        </button>
        <button type="button" (click)="setActiveTab('fees')"
          [class]="activeTab === 'fees' ? 'bg-white bg-opacity-20 text-white' : 'text-purple-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          💸 Fees/Descuentos
        </button>
        <button type="button" (click)="setActiveTab('notes')"
          [class]="activeTab === 'notes' ? 'bg-white bg-opacity-20 text-white' : 'text-purple-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          📝 Notas
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="p-6 overflow-y-auto max-h-[calc(90vh-200px)]" [formGroup]="batchConfigForm">

      <!-- TAB: Montos -->
      <div *ngIf="activeTab === 'amounts'">

        <!-- Resumen de selección -->
        <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 mb-6 border border-blue-200">
          <h4 class="font-semibold text-blue-800 mb-3">📊 Resumen de Comprobantes Seleccionados</h4>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="bg-white p-3 rounded border">
              <div class="text-sm text-gray-600">Total Comprobantes</div>
              <div class="text-lg font-bold text-blue-600">{{ totalSelectedReceipts }}</div>
            </div>
            <div class="bg-white p-3 rounded border">
              <div class="text-sm text-gray-600">Monto Original Total</div>
              <div class="text-lg font-bold text-green-600">{{ formatCurrency(totalOriginalAmount) }}</div>
            </div>
            <div class="bg-white p-3 rounded border">
              <div class="text-sm text-gray-600">Monto Banco Estimado</div>
              <div class="text-lg font-bold text-purple-600">{{ formatCurrency(estimatedBankAmount) }}</div>
            </div>
          </div>
        </div>

        <!-- Configuración de montos del banco -->
        <div class="space-y-6">

          <!-- Checkbox para aplicar montos -->
          <div class="flex items-center space-x-3">
            <input type="checkbox" formControlName="applyBankAmount"
              class="w-5 h-5 text-purple-600 focus:ring-purple-500 rounded">
            <label class="text-lg font-semibold text-gray-800">
              Aplicar monto del banco a todos los comprobantes seleccionados
            </label>
          </div>

          <!-- Opciones de configuración de montos -->
          <div *ngIf="batchConfigForm.get('applyBankAmount')?.value"
            class="bg-gray-50 rounded-lg p-6 border border-gray-200">

            <h5 class="font-semibold text-gray-800 mb-4">Seleccione el método de aplicación:</h5>

            <!-- Modo: Valor Fijo -->
            <div class="space-y-4">
              <label class="flex items-center space-x-3 cursor-pointer">
                <input type="radio" value="fixed" formControlName="bankAmountMode"
                  class="text-purple-600 focus:ring-purple-500">
                <div>
                  <div class="font-medium text-gray-800">💰 Valor Fijo por Comprobante</div>
                  <div class="text-sm text-gray-600">Aplicar el mismo monto a todos los comprobantes</div>
                </div>
              </label>

              <div *ngIf="batchConfigForm.get('bankAmountMode')?.value === 'fixed'" class="ml-6 mt-2">
                <input type="text" appCurrencyFormatter formControlName="bankAmountValue"
                  class="w-full max-w-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  placeholder="Ingrese el monto fijo">
              </div>
            </div>

            <!-- Modo: Porcentaje -->
            <div class="space-y-4 mt-4">
              <label class="flex items-center space-x-3 cursor-pointer">
                <input type="radio" value="percentage" formControlName="bankAmountMode"
                  class="text-purple-600 focus:ring-purple-500">
                <div>
                  <div class="font-medium text-gray-800">📊 Porcentaje del Original</div>
                  <div class="text-sm text-gray-600">Aplicar un porcentaje del monto original de cada comprobante</div>
                </div>
              </label>

              <div *ngIf="batchConfigForm.get('bankAmountMode')?.value === 'percentage'" class="ml-6 mt-2">
                <div class="flex items-center space-x-2">
                  <input type="number" formControlName="bankAmountPercentage" min="1" max="200" step="0.1"
                    class="w-24 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
                  <span class="text-gray-700">%</span>
                  <span class="text-sm text-gray-500">(100% = monto original)</span>
                </div>
              </div>
            </div>

            <!-- Modo: Monto Original -->
            <div class="space-y-4 mt-4">
              <label class="flex items-center space-x-3 cursor-pointer">
                <input type="radio" value="original" formControlName="bankAmountMode"
                  class="text-purple-600 focus:ring-purple-500">
                <div>
                  <div class="font-medium text-gray-800">🔄 Usar Monto Original</div>
                  <div class="text-sm text-gray-600">El monto del banco será igual al monto original de cada comprobante
                  </div>
                </div>
              </label>
            </div>
          </div>

          <!-- Preview de aplicación -->
          <div *ngIf="batchConfigForm.get('applyBankAmount')?.value && getPreviewData().length > 0"
            class="bg-yellow-50 rounded-lg p-4 border border-yellow-200">
            <h5 class="font-semibold text-yellow-800 mb-3">👀 Vista Previa (primeros 3 comprobantes):</h5>
            <div class="space-y-2">
              <div *ngFor="let preview of getPreviewData()" class="bg-white p-3 rounded border text-sm">
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-2">
                    <span>{{ getReceiptTypeIcon(preview) }}</span>
                    <span class="font-medium">#{{ preview.id }}</span>
                    <span class="text-gray-600">{{ preview.concept }}</span>
                  </div>
                  <div class="flex items-center space-x-4 text-xs">
                    <div>Original: {{ formatCurrency(preview.originalAmount) }}</div>
                    <div>→</div>
                    <div class="font-semibold">Banco: {{ formatCurrency(preview.calculatedBankAmount) }}</div>
                    <div class="font-semibold" [ngClass]="{
                           'text-green-600': preview.difference >= 0,
                           'text-red-600': preview.difference < 0
                         }">
                      ({{ preview.difference >= 0 ? '+' : '' }}{{ formatCurrency(preview.difference) }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="totalSelectedReceipts > 3" class="text-xs text-yellow-700 mt-2">
              ... y {{ totalSelectedReceipts - 3 }} comprobantes más
            </div>
          </div>
        </div>
      </div>

      <!-- TAB: Fees/Descuentos -->
      <div *ngIf="activeTab === 'fees'">

        <!-- Checkbox para aplicar fees -->
        <div class="flex items-center space-x-3 mb-6">
          <input type="checkbox" formControlName="applyFees"
            class="w-5 h-5 text-purple-600 focus:ring-purple-500 rounded">
          <label class="text-lg font-semibold text-gray-800">
            Aplicar fees/descuentos a todos los comprobantes seleccionados
          </label>
        </div>

        <!-- Configuración de fees -->
        <div *ngIf="batchConfigForm.get('applyFees')?.value" class="bg-gray-50 rounded-lg p-6 border border-gray-200">

          <!-- Header con botón agregar -->
          <div class="flex items-center justify-between mb-4">
            <h5 class="font-semibold text-gray-800">💸 Fees/Descuentos para Aplicar</h5>
            <button type="button" (click)="addFeeForBatch()"
              class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clip-rule="evenodd"></path>
              </svg>
              Agregar Fee
            </button>
          </div>

          <!-- Lista de fees para aplicar -->
          <div class="space-y-4">
            <div *ngFor="let fee of selectedFeesForBatch; let i = index"
              class="border border-gray-300 rounded-lg p-4 bg-white">

              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <!-- Tipo de Fee -->
                <div>
                  <label class="block text-gray-700 font-semibold mb-2">Tipo de Fee</label>
                  <select [value]="fee.feeTypeId" (change)="onFeeTypeChange(i, $event)"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
                    <option value="" disabled>Seleccione un tipo</option>
                    <option *ngFor="let type of feeTypes" [value]="type.id">{{ type.name }}</option>
                  </select>
                </div>

                <!-- Monto -->
                <div>
                  <label class="block text-gray-700 font-semibold mb-2">Monto</label>
                  <input type="text" [value]="fee.requestAmount" (input)="onFeeAmountChange(i, $event)"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="50000 o 10%" />
                  <span class="text-xs text-gray-500">Valor fijo ej: 50000, o porcentaje ej: 10%</span>
                </div>

                <!-- Descripción -->
                <div>
                  <label class="block text-gray-700 font-semibold mb-2">Descripción</label>
                  <input type="text" [value]="fee.description" (input)="onFeeDescriptionChange(i, $event)"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="Descripción del fee" />
                </div>
              </div>

              <!-- Botón eliminar fee -->
              <button type="button" (click)="removeFeeForBatch(i)"
                class="mt-3 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                  </path>
                </svg>
                Eliminar Fee
              </button>
            </div>

            <!-- Mensaje si no hay fees -->
            <div *ngIf="selectedFeesForBatch.length === 0"
              class="text-center py-8 text-gray-500 italic border-2 border-dashed border-gray-300 rounded-lg">
              <svg class="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                </path>
              </svg>
              No hay fees/descuentos configurados para aplicar por lotes
            </div>
          </div>

          <!-- Información adicional -->
          <div class="mt-4 p-3 bg-blue-50 rounded border border-blue-200">
            <div class="flex items-start space-x-2">
              <svg class="w-5 h-5 text-blue-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd"></path>
              </svg>
              <div class="text-sm text-blue-800">
                <div class="font-semibold mb-1">ℹ️ Información sobre Fees por Lotes:</div>
                <ul class="space-y-1 text-blue-700">
                  <li>• Los fees se aplicarán a todos los {{ totalSelectedReceipts }} comprobantes seleccionados</li>
                  <li>• Los porcentajes se calcularán sobre el monto original de cada comprobante</li>
                  <li>• Podrá ajustar individualmente después si es necesario</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TAB: Notas -->
      <div *ngIf="activeTab === 'notes'">

        <!-- Configuración de razón de ajuste -->
        <div class="space-y-6">

          <!-- Razón de Ajuste -->
          <div>
            <div class="flex items-center space-x-3 mb-4">
              <input type="checkbox" formControlName="applyAdjustmentReason"
                class="w-5 h-5 text-purple-600 focus:ring-purple-500 rounded">
              <label class="text-lg font-semibold text-gray-800">
                Aplicar razón de ajuste a todos los comprobantes
              </label>
            </div>

            <div *ngIf="batchConfigForm.get('applyAdjustmentReason')?.value"
              class="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <label class="block text-gray-700 font-bold mb-2">📝 Razón de Ajuste</label>
              <input type="text" formControlName="adjustmentReasonValue"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="Ingrese la razón del ajuste que se aplicará a todos los comprobantes" />
              <p class="text-xs text-gray-500 mt-1">Esta razón se aplicará a todos los {{ totalSelectedReceipts }}
                comprobantes seleccionados</p>
            </div>
          </div>

          <!-- Notas -->
          <div>
            <div class="flex items-center space-x-3 mb-4">
              <input type="checkbox" formControlName="applyNotes"
                class="w-5 h-5 text-purple-600 focus:ring-purple-500 rounded">
              <label class="text-lg font-semibold text-gray-800">
                Aplicar notas a todos los comprobantes
              </label>
            </div>

            <div *ngIf="batchConfigForm.get('applyNotes')?.value"
              class="bg-gray-50 rounded-lg p-4 border border-gray-200">

              <!-- Modo de aplicación de notas -->
              <div class="mb-4">
                <label class="block text-gray-700 font-bold mb-2">Modo de Aplicación:</label>
                <div class="space-y-2">
                  <label class="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" value="replace" formControlName="notesMode"
                      class="text-purple-600 focus:ring-purple-500">
                    <span class="text-gray-800">🔄 Reemplazar notas existentes</span>
                  </label>
                  <label class="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" value="append" formControlName="notesMode"
                      class="text-purple-600 focus:ring-purple-500">
                    <span class="text-gray-800">➕ Agregar a notas existentes</span>
                  </label>
                </div>
              </div>

              <!-- Campo de notas -->
              <label class="block text-gray-700 font-bold mb-2">📋 Notas</label>
              <textarea formControlName="notesValue"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 resize-none"
                rows="4"
                placeholder="Ingrese las notas que se aplicarán a todos los comprobantes seleccionados"></textarea>
              <p class="text-xs text-gray-500 mt-1">
                Estas notas se {{ batchConfigForm.get('notesMode')?.value === 'replace' ? 'reemplazarán' : 'agregarán a'
                }}
                las notas existentes en los {{ totalSelectedReceipts }} comprobantes seleccionados
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="bg-gray-50 px-6 py-4 flex items-center justify-between border-t">
      <div class="flex items-center space-x-4">
        <!-- Resumen de configuración -->
        <div class="text-sm text-gray-600">
          <span class="font-medium">{{ totalSelectedReceipts }} comprobantes</span> serán configurados
        </div>
      </div>

      <div class="flex items-center space-x-3">
        <button type="button" (click)="onReset()"
          class="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors">
          Limpiar
        </button>
        <button type="button" (click)="onClose()"
          class="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors">
          Cancelar
        </button>
        <button type="button" (click)="onApply()" [disabled]="!isFormValid()"
          class="px-6 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg transition-colors">
          Aplicar Configuración
        </button>
      </div>
    </div>
  </div>
</div>